import React from "react";

export const caricaturaSubtitle = (
  <div>
    De Oswaldo Díaz Díaz, publicada en la revista estudiantil del Gimnasio Moderno <i>El Aguilucho</i>, No. 115, en
    junio de 1954
  </div>
);

export const caricaturaContent = (
  <div>
    <p className="content justified">
      “Los que nos dedicamos a la enseñanza bien sabemos que hay tres imperativos a los que estamos sometidos: el apodo,
      la caricatura y el ser remedados. En materia de caricaturas tengo una buena colección y con firmas ya ilustres”.
      Oswaldo Díaz Díaz
    </p>
    <p className="content justified">
      Don Os fue profesor de la Escuela Nacional de Comercio en 1936. En 1941 trabajó en el Colegio Nacional de San
      Bartolomé como secretario, y luego fue nombrado vicerrector. Entre 1944 y 1947 fue el vicerrector del Gimnasio
      Moderno, donde trabajó por casi dos décadas como profesor y director del Club Dramático.
    </p>
    <p className="content justified">
      Fue nombrado Director de Enseñanza Secundaria en el Ministerio de Educación Nacional, pero renunció y fundó el
      colegio Libertad y Orden en 1948, el cual funcionó hasta 1949.
    </p>
    <p className="content justified">
      También fue docente en colegios como: Liceo Nacional Femenino, Instituto Pedagógico Nacional, Colegio de la
      Presentación – Chapinero, Centro de las Mercedes y el Colegio Elviras Lleras. Y en la Universidad de los Andes, la
      Pontificia Universidad Javeriana, la Universidad Nacional Pedagógica Femenina y en el Instituto Universitario de
      Historia de Colombia.
    </p>
  </div>
);
